import kadenPic from "@/public/images/artists/kaden.png";
import { Artist } from "@/types/types";

export const kaden = {
  id: "248",
  name: "Kaden",
  image: kadenPic,
  description: `Kaden's voice is light and melodic, with an easy rhythmic cadence. His delivery is smooth and articulate, balancing warmth and clarity. He speaks with a natural musicality—measured, expressive, and perfectly suited for spoken word.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fkaden-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Spoken Word"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 45,
        high: 51,
      },
      sweetSpot: 48,
    },
  },
} as const satisfies Artist;
